import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'rutFormatter' })
export class RutFormatterPipe implements PipeTransform {
    transform(rut: string) {
        let rutPuntos = '';
        if(rut){
            const actual = rut.replace(/^0+/, "");
            if (actual !== '' && actual.length > 1) {
                const sinPuntos = actual.replace(/\./g, "");
                const actualLimpio = sinPuntos.replace(/-/g, "");
                const inicio = actualLimpio.substring(0, actualLimpio.length - 1);
                for (let i = inicio.length - 1, j = 1; i >= 0; i--, j++) {
                    const letra = inicio.charAt(i);
                    rutPuntos = letra + rutPuntos;
                    if (j % 3 === 0 && j <= inicio.length - 1) {
                        rutPuntos = "." + rutPuntos;
                    }
                }
                const dv = actualLimpio.substring(actualLimpio.length - 1);
                rutPuntos = rutPuntos + "-" + dv;
            }
        }
       
        return rutPuntos;
    }

}